import {
	Card,
	Typography,
	type CardProps,
	type TypographyProps,
} from '@mui/material'
import { type ComponentType } from 'react'
import { styled } from '@mui/material/styles'

export const SMALL_BREAKPOINT = 700

export const ContactUsCard: ComponentType<CardProps> = styled( Card )( ( { theme } ) => ( {
	display: 'inline-flex',
	alignItems: 'center',
	marginBottom: theme.spacing( 2 ),
	padding: theme.spacing( 3, 2 ),
	borderRadius: theme.shape.borderRadius,
	boxShadow: 'none',
	border: `1px solid ${theme.palette.grey[ 300 ]}`,

	[ theme.breakpoints.down( SMALL_BREAKPOINT ) ]: {
		width: '100%',
		flexDirection: 'column',
	},
} ) )

export const ContactUsText: ComponentType<TypographyProps> = styled( Typography )( ( { theme } ) => ( {
	marginRight: theme.spacing( 3 ),
	fontWeight: theme.typography.fontWeightMedium,

	[ theme.breakpoints.down( SMALL_BREAKPOINT ) ]: {
		marginBottom: theme.spacing( 2 ),
	},
} ) )
